
/**
 * terms: 이용약관
 * policy_1: 개인정보 수집 및 이용에 대한 안내
 * policy_2: 개인정보 처리위탁 안내
 * policy_3: 개인정보의 마케팅 활용 및 광고성 메시지 수신 동의 (회원가입)
 * policy_4: 개인정보의 마케팅 활용 및 광고성 메시지 수신 동의 (문자회원신청및철회, 정보수정)
 * policy_5: 초록이네(온라인 MD샵) 제3자 정보제공 동의 안내
 * policy_6: 초록이네(온라인 MD샵) 개인정보 이관 동의 안내
 * policy_7: 설문조사 개인정보 동의 안내
 * policy_8: 야간 광고성 메세지 수신 동의 (정보변경)
 * draw : 회원탈퇴
 * eventTerms : 이벤트 (개인정보 수집 및 이용에 관한 동의사항)
 * eventTermForVote : 이벤트_투표용 ()
 * policyOfGiftTk_1 : 개인정보 수집 및 이용에 대한 안내 (필수 - 스마트티켓 선물하기)
 * policyOfGiftTk_2 : 개인정보의 마케팅 활용 및 광고성 메시지 수신동의(선택 - 스마트티켓 선물하기)
 * quiz_info: 퀴즈 안내사항
 */
export default {
    terms: `
이 약관은 전기통신 사업법 및 동 법 시행령에 의하여 전북현대모터스에프씨 주식회사 (이하 "회사" 라 합니다.)가 제공하는 인터넷 홈페이지 서비스 (이하 "서비스" 라 합니다.)의 이용조건 및 절차에 관한 사항, 회사와 이용자의 권리와 의무 및 책임사항을 규정함을 목적으로 합니다.<br>
<br>
제 1조 (목적)<br>
<br>
이 약관은 전기통신 사업법 및 동 법 시행령에 의하여 전북현대모터스에프씨 주식회사 (이하 "회사" 라 합니다.)가 제공하는 인터넷 홈페이지 서비스 (이하 "서비스" 라 합니다.)의 이용조건 및 절차에 관한 사항, 회사와 이용자의 권리와 의무 및 책임사항을 규정함을 목적으로 합니다.<br>
<br>
<br>
제 2조 (약관의 효력과 개정)<br>
<br>
이 약관은 전기통신사업법 제 31 조, 동 법 시행규칙 제 21조의 2에 따라 공시절차를 거친 후 홈페이지를 통하여 이를 공지하거나 전자우편 기타의 방법으로 이용자에게 통지함으로써 효력을 발생합니다.<br>
회사는 본 약관을 사전 고지 없이 개정할 수 있으며, 개정된 약관은 제9조에 정한 방법으로 공지합니다. 회원은 개정된 약관에 동의하지 아니하는 경우 본인의 회원등록을 취소(회원탈퇴)할 수 있으며, 계속 사용의 경우는 약관 개정에 대한 동의로 간주됩니다. 개정된 약관은 공지와 동시에 그 효력이 발생됩니다.<br>
<br>
<br>
제 3조 (약관이외의 준칙)<br>
<br>
이 약관에 명시되어 있지 않은 사항은 전기통신 기본법, 전기통신 사업법, 기타 관련법령의 규정에 따릅니다.<br>
<br>
<br>
제 4조 (용어의 정의)<br>
<br>
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br>
회원 : 서비스에 개인정보를 제공하여 회원등록을 한 자로서, 서비스의 정보를 지속적으로 제공받으며, 이용할 수 있는 자를 말합니다.<br>
이용자 : 본 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.<br>
아이디 (ID) : 회원 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 문자와 숫자의 조합을 말합니다.<br>
비밀번호 : 회원이 통신상의 자신의 비밀을 보호하기 위해 선정한 문자와 숫자의 조합을 말합니다.<br>
전자우편 (E-mail) : 인터넷을 통한 우편입니다.<br>
해지 : 회사 또는 회원이 서비스 이용 이후 그 이용계약을 종료 시키는 의사표시를 말합니다.<br>
홈페이지 : 회사가 이용자에게 서비스를 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 이용자가 열람 및 이용할 수 있도록 설정한 가상의 서비스 공간을 말합니다.<br>
<br>
<br>
제 5조 (서비스의 제공 및 변경)<br>
<br>
회사가 제공하는 서비스는 다음과 같습니다.<br>
1) 회사에 대한 홍보 내용<br>
2) 회사가 판매하는 제품 안내<br>
3) 기타 회사가 제공하는 각종 정보<br>
4) 고객 상담 서비스<br>
5) 회원 이용 서비스<br>
회사는 필요한 경우 서비스의 내용을 추가 또는 변경하여 제공할 수 있습니다.<br>
<br>
<br>
제 6조 (서비스의 중단)<br>
<br>
회사는 컴퓨터 등 정보통신설비의 보수점검/교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.<br>
제 1항에 의한 서비스 중단의 경우에는 제 9조에 정한 방법으로 이용자에게 통지합니다.<br>
회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상하지 아니합니다. 단, 회사에 고의 또는 중과실이 있는 경우에는 그러하지 아니합니다.<br>
<br>
<br>
제 7조 (회원가입)<br>
<br>
이용자는 회사가 정한 가입양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.<br>
회사는 제 1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.<br>
1) 이름이 실명이 아닌 경우<br>
2) 등록 내용에 허위, 기재누락, 오기가 있는 경우<br>
3) 타인의 명의를 사용하여 신청한 경우<br>
4) 가입신청자가 이 약관 제 8조 3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우(단, 제 8조 3항에 의한 회원자격 상실 후 3년이 경과한 자로서 회사의 회원 재가입 승낙을 얻은 경우는 예외로 합니다.)<br>
5) 기타 회원으로 회사 소정의 이용신청요건을 충족하지 못하는 경우<br>
<br>
회원가입계약의 성립시기는 회사의 승낙이 이용자에게 도달한 시점으로 합니다.<br>
회원은 제 10조 1항에 의한 등록사항에 변경이 있는 경우 회원정보변경 항목을 통해 직접 변경사항을 수정, 등록하여야 합니다.<br>
<br>
<br>
제 8조 (회원탈퇴 및 자격 상실 등)<br>
<br>
회원은 언제든지 회원의 탈퇴를 홈페이지에 요청할 수 있으며, 홈페이지는 즉시 이에 응합니다.<br>
회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.<br>
1) 가입 신청 시에 허위 내용을 등록한 경우<br>
2) 타인의 서비스 이용을 방해하거나 그 정보를 도용하는 등 서비스 운영질서를 위협하는 경우<br>
3) 서비스를 이용하여 법령과 이 약관이 금지하거나, 공서양속에 반하는 행위를 하는 경우<br>
4) 제 13조 에 명기된 회원의 의무사항을 준수하지 못할 경우<br>
5) 회원은 마지막 로그인 5년 초과한 경우<br>
(다만, 포인트 미 소유자에 한하며 사전 30일전 고지 이후 회원 탈퇴 및 자격 상실)<br>
회사가 회원자격을 제한/정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을 상실 시킬 수 있습니다.<br>
회사가 회원자격을 상실 시키는 경우 회원에게 이를 통지하고 탈퇴를 처리합니다. 이 경우 회원에게 이를 통지하고, 탈퇴 전에 소명할 기회를 부여합니다.<br>
<br>
<br>
제 9조 (이용자에 대한 통지)<br>
<br>
회사가 이용자에 대한 통지를 하는 경우, 이용자가 서비스에 제출한 전자우편 주소로 할 수 있습니다.<br>
회사가 불특정 다수 이용자에 대한 통지의 경우 1주일 이상 서비스 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.<br>
<br>
<br>
제 10조 (개인 정보 보호)<br>
<br>
회원 및 이용자의 개인정보 보호에 관한 사항은 회사 공식 홈페이지에 공개된 개인정보처리방침에 따릅니다.<br>
<br>
<br>
제 11조 (회사의 의무)<br>
<br>
회사는 이 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 수 있도록 최선의 노력을 다하여야만 합니다.<br>
회사는 서비스에 관련된 설비를 항상 운용할 수 있는 상태로 유지/보수하고, 장애가 발생하는 경우 지체 없이 이를 수리/복구할 수 있도록 최선의 노력을 다하여야 합니다.<br>
회사는 이용자가 안전하게 서비스를 이용할 수 있도록 이용자의 개인정보보호를 위한 보안시스템을 갖추어야 합니다.<br>
회사는 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.<br>
<br>
<br>
제 12조 (회원의 ID 및 비밀번호에 대한 의무)<br>
<br>
회원에게 부여된 아이디(ID)와 비밀번호의 관리책임은 회원에게 있으며 관리 소홀, 부정사용에 의하여 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.<br>
회원이 자신의 ID 및 비밀번호를 도난 당하거나 제 3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.<br>
<br>
<br>
제 13조 (회원의 의무)<br>
<br>
회원은 관계법령, 본 약관의 규정, 이용안내 및 주의사항 등 회사가 통지하는 사항을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안됩니다.<br>
회원은 회사의 사전승낙 없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.<br>
회원은 서비스를 이용하여 얻은 정보를 회사의 사전승낙 없이 복사, 복제, 변경, 번역, 출판/방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.<br>
회원은 자기 신상정보의 변경사항 발생시 즉각 변경하여야 합니다. 회원정보를 수정하지 않아 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.<br>
회원은 서비스 이용과 관련하여 다음 각 호의 행위를 하지 않아야 하며, 다음 행위를 함으로 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.<br>
1) 다른 회원의 아이디(ID)를 부정하게 사용하는 행위<br>
2) 다른 회원의 E-mail 주소를 취득하여 스팸메일을 발송하는 행위<br>
3) 범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위<br>
4) 선량한 풍속, 기타 사회질서를 해하는 행위<br>
5) 회사 및 타인의 명예를 훼손하거나 모욕하는 행위<br>
6) 회사 및 타인의 지적재산권 등의 권리를 침해하는 행위<br>
7) 해킹행위 또는 컴퓨터 바이러스의 유포행위<br>
8) 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위<br>
9) 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위<br>
10) 회사가 제공하는 서비스의 내용을 변경하는 행위<br>
11) 기타 관계법령에 위배되는 행위<br>
<br>
<br>
<br>
제 14조 (게시물 삭제)<br>
<br>
회사는 이용자가 게시하거나 등록하는 서비스내의 게시물이 제 13조의 규정에 위반되거나, 다음 각 호에 해당한다고 판단되는 경우 사전통지 없이 게시물을 삭제할 수 있습니다.<br>
1) 다른 이용자 또는 제 3자를 비방하거나 중상모략으로 명예를 손상시키는 내용<br>
2) 공공질서 또는 미풍양속에 위반되는 내용<br>
3) 범죄적 행위에 결부된다고 인정되는 내용<br>
4) 제 3자의 저작권 등 기타 권리를 침해하는 내용<br>
5) 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 내용<br>
6) 근거나 확인절차 없이 회사를 비난하거나 유언비어를 유포한 내용<br>
7) 기타 관계법령에 의거하여 위반된다고 판단되는 내용<br>
<br>
회사는 이용자가 게시하거나 등록하는 서비스내의 게시물이 제 13조의 규정에 위반되거나 동 조 제1항 각 호에 해당한다고 판단되는 정보를 링크하고 있을 경우 사전통지 없이 게시물을 삭제할 수 있습니다.<br>
<br>
<br>
<br>
제 15조 (게시물에 대한 권리 / 의무)<br>
<br>
게시물에 대한 저작권을 포함한 모든 권리 및 책임은 이를 게시한 이용자에게 있습니다.<br>
<br>
<br>
제 16조 (연결 "홈페이지"와 피연결 "홈페이지"간의 관계)<br>
<br>
상위 "홈페이지"와 하위 "홈페이지"가 하이퍼 링크(예:하이퍼 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨) 방식 등으로 연결된 경우, 전자를 연결 "홈페이지"라고 하고 후자를 피연결 "홈페이지(웹사이트)"라고 합니다.<br>
연결 "홈페이지"는 피연결 "홈페이지"가 독자적으로 제공하는 재화• 용역에 의하여 이용자와 행하는 거래에 대해서 보증책임을 지지 않습니다.<br>
<br>
<br>
제 17조 (저작권의 귀속 및 이용제한)<br>
<br>
회사가 작성한 저작물에 대한 저작권 및 기타 지적재산권은 회사에 귀속합니다.<br>
이용자는 서비스를 이용함으로써 얻은 정보를 회사의 사전승낙 없이 복제, 송신, 출판, 배포, 방송, 기타 방법에 의하여 영리목적으로 이용하거나 제 3자에게 이용하게 하여서는 안됩니다.<br>
<br>
<br>
제 18조 (양도금지)<br>
<br>
회원이 서비스의 이용권한, 기타 이용 계약상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.<br>
<br>
<br>
제 19조 (손해배상)<br>
<br>
회사는 무료로 제공되는 서비스와 관련하여 이용자에게 어떠한 손해가 발생하더라도 동 손해가 회사의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부여하지 아니합니다.<br>
<br>
<br>
제 20조 (면책 / 배상)<br>
<br>
회사는 이용자가 서비스에 게재한 정보, 자료, 사실의 정확성, 신뢰성 등 그 내용에 관하여는 어떠한 책임을 부담하지 아니하고, 이용자는 자신의 책임아래 서비스를 이용하며, 서비스를 이용하여 게시 또는 전송한 자료 등에 관하여 손해가 발생하거나 자료의 취사선택, 기타 서비스 이용과 관련하여 어떠한 불이익이 발생하더라도 이에 대한 모든 책임은 이용자에게 있습니다.<br>
회사는 제 13조의 규정에 위반하여 이용자간 또는 이용자와 제 3자간에 서비스를 매개로 한 물품거래 등과 관련하여 어떠한 책임도 부담하지 아니하고, 이용자가 서비스의 이용과 관련하여 기대하는 이익에 관하여 책임을 부담하지 않습니다.<br>
이용자가 제 13조, 기타 이 약관의 규정을 위반함으로 인하여 회사가 이용자 또는 제 3자에 대하여 책임을 부담하게 되고, 이로써 회사에게 손해가 발생하게 되는 경우, 이 약관을 위반한 이용자는 회사에게 발생하는 모든 손해를 배상하여야 하며, 동 손해로부터 회사를 면책시켜야 합니다.<br>
<br>
<br>
제 21조 (분쟁의 해결)<br>
<br>
회사와 이용자는 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.<br>
제 1항의 규정에도 불구하고, 동 분쟁으로 인하여 소송이 제기될 경우 동 소송은 서울지방법원을 관할로 합니다.<br>
동 소송에는 대한민국 법을 적용합니다.<br>
<br>
<br>
제 22조 (기타)<br>
<br>
이 약관에 명시되지 아니한 사항의 처리를 위하여 이용자는 전북현대모터스축구단.(전화번호 : 063-273-1763~5)를 이용합니다.<br>
<br>
부칙<br>
이 약관은 2024년 5월 7일부터 시행합니다.<br>
    `,
    policy_1: `
전북현대모터스에프씨 주식회사(이하 전북현대)는 전북현대 웹사이트에 회원가입을 신청하시는 이용자(정보주체)께 개인정보의 수집∙이용 목적, 수집하는 개인정보의 항목, 개인정보의 보유∙이용 기간을 안내하고 있습니다. 자세히 읽은 후 동의여부를 선택하여 주시기 바랍니다.<br>
<br>
□ 개인정보의 수집∙이용 목적 안내<br>
전북현대는 이용자께서 전북현대 웹사이트([www.hyundai-motorsfc.com](http://www.hyundai-motorsfc.com/))의 개인정보 수집∙이용 목적에 대하여 「동의함」 버튼 또는 「동의 안 함」 버튼을 클릭할 수 있는 절차를 마련하여, 「동의함」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 간주합니다.<br>
<br>
전북현대 웹사이트는 회원가입 시 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다.<br>
수집한 개인정보는 고지한 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 이용자(정보주체)께 변경사항을 고지하고 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br>
<br>
□ 수집하는 개인정보 항목<br>
① 필수 수집 항목 : 본인인증을 통한 “이름, 휴대폰번호, 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)”, 아이디, 휴대폰번호(아이핀을 통한 본인인증 시 별도 입력), 이메일주소, 우편번호, 좋아하는 선수<br>
② 선택 수집 항목 : 광고성 메시지 수신 및 야간 광고성 수신 동의 여부, 직업, 결혼 여부, 전주공장 사원번호<br>
③ 14세 미만 회원 추가 수집항목 : 법정대리인 본인 인증을 통한 “이름, 휴대폰 번호, 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI), 휴대폰번호(아이핀을 통한 본인인증시 별도 입력)<br>
<br>
□ 개인정보의 이용 목적<br>
- 아이디, 이름, 생년월일, 성별, 휴대폰번호, 이메일주소, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI) : 회원가입 의사 확인, 회원제 서비스(티켓 예매, 포인트 제도, 쿠폰 제공, 신청형 이벤트, 참여형 이벤트) 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지, 고충처리 목적<br>
- 우편번호, 좋아하는 선수, 직업, 결혼여부 : 회원제 서비스 제공(티켓 예매, 포인트 제도, 쿠폰 제공, 신청형 이벤트, 참여형 이벤트)시 맞춤형 서비스 제공 및 마케팅 활용 목적<br>
- 만 14세 미만 아동의 개인정보 처리시 법정대리인의 동의여부 확인<br>
<br>
□ 개인정보의 보유∙이용 기간<br>
전북현대 웹사이트에서 수집한 개인정보의 보유∙이용 기간은 회원가입 직후부터 회원탈퇴시까지입니다. 회원탈퇴 시 전북현대 웹사이트는 이용자(정보주체)의 개인정보를 지체없이 파기합니다.<br>
파기는 재생이 불가능한 방법으로 안전하게 이루어집니다. 다만, 다음 각 호에 해당하는 경우에는 회원탈퇴를 하였더라도 각 호에 명시한 기간 동안 개인정보를 보유할 수 있습니다.<br>
14세 미만 회원가입의 경우 14세 미만 아동의 법정 대리인 정보는 해당 아동이 만 14세가 될 때까지 보관됩니다.<br>
<br>
① 『전자상거래 등에서의 소비자보호에 관한 법률』, 『통신비밀보호법』 등 법령에 의하여 보존해야하는 경우에는 해당 법령에서 규정한 기간 동안 개인정보를 보유할 수 있습니다.<br>
- 계약 또는 청약철회 등에 관한 기록, 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br>
- 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래 등에서의 소비자보호에 관한 법률)<br>
- 「통신비밀보호법」에 따른 서비스이용기록, 접속로그, 접속IP정보 : 3개월<br>
② 개인정보의 보유 기간을 이용자(정보주체)께 미리 고지하고 동의를 받은 다음 그 보유 기간이 경과하지 않은 경우 및 개별적으로 이용자(정보주체)의 동의를 받은 경우에는 약속한 기간 동안 보유할 수 있습니다.<br>
<br>
□ 동의를 거부할 권리 및 동의 거부 시 불이익<br>
회원가입 시 수집하는 개인정보는 전북현대 웹사이트의 회원제 서비스 이용을 위해 필요한 최소한의 개인정보이므로 수집∙이용 동의를 해주셔야 회원제 서비스 이용이 가능합니다.<br>
이용자(정보주체)는 개인정보의 수집목적 및 이용목적에 대한 동의를 거부할 수 있으며, 동의 거부시 전북현대 웹사이트에 회원가입이 되지 않으며, 전북현대 웹사이트에서 제공하는 제한적인 회원제 서비스(티켓 예매, 포인트 제도, 쿠폰 제공, 신청형 이벤트, 참여형 이벤트)서비스를 이용하실 수 없습니다.<br>
    `,
    policy_2: `
전북현대모터스에프씨 주식회사(이하 전북현대)는 원활한 서비스 제공을 위하여 아래의 사업자에게 개인정보 처리 업무를 위탁하고 있습니다. 자세한 사항은 아래와 같습니다. 전북현대는 개인정보 처리를 수탁한 사업자가 개인정보를 안전하게 처리하는지 감독하고 있습니다.<br><br>
&lt;전북현대 웹사이트 운영&gt;<br>
- 수탁업체 : 더스포츠커뮤니케이션<br>
- 수탁목적 : 전북현대 웹사이트 서비스 운영 및 관리<br>
- 처리항목 : 본인인증을 통한 “이름, 휴대폰번호, 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)”, 아이디, 휴대폰번호(아이핀을 통한 본인인증시 별도 입력), 이메일주소, 우편번호, 좋아하는 선수, 직업, 결혼 여부 및 광고성 메시지 수신 동의 여부<br>
- 개인정보 처리위탁 기간 : 회원 탈퇴 시 혹은 위탁계약 종료 시까지<br><br>
&lt;전북현대 데이터 기반 마케팅 계획 수립 대행 및 운영&gt;<br>
- 수탁업체 : 더스포츠커뮤니케이션<br>
- 수탁목적 : 전북현대 데이터 기반 마케팅 계획 수립 및 운영<br>
- 처리항목 : 아이디, 이름, 휴대폰번호, 생년월일, 성별, 우편번호, 좋아하는 선수, 직업, 결혼 여부,광고성 메시지 수신 동의 여부, 티켓 구매내역, MD쇼핑몰 구매내역, 웹사이트 접속 빈도<br>
- 개인정보 처리위탁 기간 : 마케팅 활용 동의 철회 시, 회원 탈퇴 시 혹은 위탁계약 종료 시까지<br><br>
&lt;전북현대 티켓 예매 운영&gt;<br>
- 수탁업체 : 엔에이치엔링크 주식회사<br>
- 수탁목적 : 전북현대 티켓 서비스 운영 및 관리<br>
- 처리항목 : 아이디, 이름, 생년월일, 휴대폰번호, 이메일주소(입력 시) 및 티켓 구매 정보 일체<br>
- 개인정보 처리위탁 기간 : 회원 탈퇴 시 혹은 위탁계약 종료 시까지(단, 상법 등 관계 법령의 규정에 의하여 보존할 의무가 있거나, 민원 처리 및 분쟁 대응 등의 사유로 개인정보 처리목적이 달성되지 않은 경우에는 처리목적 달성 시점까지 보유 및 이용합니다)<br><br>
&lt;전북현대 MD쇼핑몰 운영&gt;<br>
- 수탁업체 : 에스아이엘, 더스포츠커뮤니케이션, 엔에이치엔커머스 주식회사<br>
- 수탁목적 : 전북현대 MD쇼핑몰 서비스 운영 및 관리, 배송<br>
- 처리항목 : 아이디, 이름, 주문자 정보(이름, 우편번호, 주소, 휴대폰번호, 이메일주소), 수령인 정보(이름, 우편번호, 주소, 휴대폰번호, 이메일주소), 주문∙결제 승인정보 및 환불 정보(금융사, 계좌번호, 예금주명)<br>
- 개인정보 처리위탁 기간 : 회원 탈퇴 시 혹은 위탁계약 종료 시까지(단, 상법 등 관계 법령의 규정에 의하여 보존할 의무가 있거나, 민원 처리 및 분쟁 대응 등의 사유로 개인정보 처리목적이 달성되지 않은 경우에는 처리목적 달성 시점까지 보유 및 이용합니다)<br>
※ 이용자(정보주체)는 개인정보 처리위탁 동의를 거부할 권리가 있습니다. 단, 동의를 거부할 경우에는 전북현대 웹사이트 회원가입이 불가하며 회원을 대상으로 제공하는 회원제 서비스(티켓 예매, 포인트 제도, 쿠폰 제공, 신청형 이벤트, 참여형 이벤트)를 이용하실 수 없습니다.<br><br>
&lt;현대자동차 전주공장 임직원 할인 정책 적용&gt;<br>
- 수탁업체 : 현대자동차(주) 전주공장<br>
- 수탁목적 : 현대자동차 전주공장 임직원 할인 정책 적용<br>
- 처리항목 : 아이디, 이름, 휴대폰번호, 생년월일, 사원번호, 가족수<br>
- 개인정보 처리위탁 기간 : 회원 턀퇴시까지 혹은 매년 12월 31일 일괄 삭제
    `,
    policy_3: `
전북현대모터스에프씨 주식회사(이하 전북현대)는 전북현대 웹사이트 이용자(정보주체)를 대상으로 맞춤형 마케팅을 진행하기 위하여 개인정보의 마케팅 활용 및 광고성 메시지 수신 동의를 받고 있습니다.<br><br>
① 마케팅 목적으로 처리하는 개인정보 항목<br>
: 이름, 휴대폰번호, 생년월일, 성별, 우편번호, 좋아하는 선수, 티켓 구매내역, 웹사이트 접속 빈도<br><br>
② 개인정보의 세부 처리 목적<br>
- 서비스 안내 및 개선에 활용 : 경기 관람을 위한 정보 안내, 서비스 및 만족도 조사, 회원의 서비스 이용 통계 집계 및 분석, 신규 서비스 개발을 위한 리서치<br>
- 맞춤형 마케팅에 활용 : 접속 빈도, 티켓 구매내역에 따른 포인트 지급, 쿠폰 제공<br>
- 맞춤형 메시지 발송에 활용 : 전자적 전송매체를 이용한 이벤트 정보, 프로모션 정보 등의 광고성 메시지 발송<br><br>
③ 개인정보 수집 방법<br>
- 전북현대가 운영하는 전북현대 웹사이트 회원가입을 통한 수집<br>
- 티켓예매 위탁사를 통한 수집(개인정보의 제3자 제공)<br><br>
④ 개인정보 보유 및 이용 기간<br>
: 회원탈퇴 또는 동의 철회 시<br><br>
⑤ 동의를 거부할 권리 및 동의 거부 시 불이익<br>
: 이용자(정보주체)는 개인정보의 마케팅 활용 및 광고성 메시지 수신 동의를 거부할 권리가 있습니다.<br>
단, 동의를 거부하는 경우에는 포인트 지급(적립 및 사용)이 어려우며 경품, 맞춤형 쿠폰 제공이 어렵습니다. 그 밖의 불이익은 없습니다.
    `,
    draw : `
    포인트/혜택(등급) 및 재 가입시 복구 불가<br>
<br>
- 회원 탈퇴 시, 회원님 아이디에 등록된 적립금과 혜택(등급)에 관련 된 사항은 모두 소멸되어, 재 가입을 하더라도 복구되지 않습니다.<br>
- 시즌권, 멤버십, 티켓구매 내역 등은 삭제가 되며, 재 가입 후 재 등록 절차를 진행하셔야 합니다.<br>
<br>
관계법령에 따른 주문번호는 회원 탈퇴 후 5년간 보존<br>
<br>
- 전자상거래 등에서의 소비자 보호에 관한 법률 제6조(거래기록의 보존 등)에 의거, 주문정보는 회원 탈퇴 후 5년간 보존됩니다.<br>
- 티켓 예매 후 탈퇴 시에 경기 관람은 가능하나 예매번호, 예매내역을 볼 수 없으며, 예매취소/변경은 예매번호를 가지고 티켓 대행사 고객센터를 통해서만 진행가능합니다.<br>
    `,
    policy_4: `
전북현대모터스에프씨 주식회사(이하 전북현대)는 전북현대 웹사이트 이용자(정보주체)를 대상으로 맞춤형 마케팅을 진행하기 위하여 개인정보의 마케팅 활용 및 광고성 메시지 수신 동의를 받고 있습니다.<br><br>
① 마케팅 목적으로 처리하는 개인정보 항목<br>
: 이름, 휴대폰번호, 생년월일, 성별, 우편번호, 좋아하는 선수, 티켓 구매내역, 웹사이트 접속 빈도<br><br>
② 개인정보의 세부 처리 목적<br>
- 서비스 안내 및 개선에 활용 : 경기 관람을 위한 정보 안내, 서비스 및 만족도 조사, 회원의 서비스 이용 통계 집계 및 분석, 신규 서비스 개발을 위한 리서치<br>
- 맞춤형 마케팅에 활용 : 접속 빈도, 티켓 구매내역에 따른 포인트 지급, 쿠폰 제공<br>
- 맞춤형 메시지 발송에 활용 : 전자적 전송매체를 이용한 이벤트 정보, 프로모션 정보 등의 광고성 메시지 발송<br><br>
③ 개인정보 수집 방법<br>
- 전북현대가 운영하는 전북현대 웹사이트 회원가입을 통한 수집<br>
- 티켓예매 위탁사를 통한 수집(개인정보의 제3자 제공)<br><br>
④ 개인정보 보유 및 이용 기간<br>
: 회원탈퇴 또는 동의 철회 시<br><br>
⑤ 동의를 거부할 권리 및 동의 거부 시 불이익<br>
: 이용자(정보주체)는 개인정보의 마케팅 활용 및 광고성 메시지 수신 동의를 거부할 권리가 있습니다.<br><br>
단, 동의를 거부하는 경우에는 포인트 지급(적립 및 사용)이 어려우며 경품, 맞춤형 쿠폰 제공이 어렵습니다. 그 밖의 불이익은 없습니다.<br>
    `,
    policy_5: `
에스아이엘이 제공한 상품 및 서비스를 이용한 구매기록과 포인트를 이용하고자 할 경우, 에스아이엘은 구매기록과 포인트 제공을 위하여 필요한 최소한의 개인정보만을 아래와 같이 제공하고 있습니다. 에스아이엘은 정보통신망 이용촉진 및 정보보호 등에 관한 법률에 따라 아래와 같이 개인정보 제공에 대한 사항을 안내드리오니 자세히 읽은 후 동의하여 주시기 바랍니다.<br><br>
1. 개인정보를 제공받는 자<br>
- 전북현대모터스에프씨 주식회사<br><br>
2. 제공하는 개인정보 항목<br>
- 전북현대모터스에프씨 주식회사 : 아이디, 이름, 이메일 주소, 연락처, 휴대폰번호, 결제금액, 포인트<br><br>
3. 개인정보를 제공받는 자의 이용목적<br>
- 전북현대모터스에프씨 주식회사 : 구매내역 및 포인트 제공<br><br>
4. 개인정보를 제공받는 자의 개인정보 보유 및 이용기간<br>
- 전북현대모터스에프씨 주식회사 : 개인정보 이용목적 달성 시까지. 단, 관계법령의 규정에 의해 보존의 필요가 있는 경우 및 사전 동의를 득한 경우 해당 보유기간까지.<br><br>
5. 동의거부권 등에 대한 고지<br>
- 본 개인정보 제공에 동의하지 않으시는 경우, 동의를 거부할 수 있으며, 이 경우 포인트 제공이 제한될 수 있습니다.
    `,
    policy_6: `
전북현대 MD샵인 ‘초록이네’ 운영 주체 변경에 따라 초록이네 MD샵은 2022년 12월 29일자로 전북현대모터스에프씨 MD샵으로 이관하여 통합 운영됩니다. 본건 사업 이관으로 인하여 고객님께 지속적인 서비스 제공을 위하여 에스아이엘에서 보관중인 고객님의 정보를 전북현대모터스에프씨에 주식회사에 제공하고자 합니다. 전북현대모터스에프씨는 이전되는 개인정보를 안전하게 관리하며 개인정보를 수집한 당시의 본래 목적으로만 처리할 것입니다.<br><br>
개인정보 이관처<br>
- 상호명 : 전북현대모터스에프씨 주식회사<br>
- 주소 : 전라북도 전주시 덕진구 기린대로 1055 전주월드컵경기장 2층<br>
- 전화번호 : (063)273-1763<br><br>
개인정보 이용 목적<br>
: 전북현대 MD샵 ‘초록이네’ 서비스 이관에 따른 지속적인 MD샵 서비스 제공<br><br>
제공하는 개인정보 항목<br>
: 아이디, 이름, 이메일 주소, 연락처, 휴대폰번호, 결제금액, 포인트<br><br>
개인정보 보유 및 이용기관<br>
: 개인정보 이용목적 달성 시까지. 단, 관계법령의 규정에 의해 보존의 필요가 있는 경우 및 사전 동의를 득한 경우 해당 보유기간까지.<br><br>
개인정보 수집 이용 동의 철회 안내<br>
: 본 개인정보 이관 동의를 거부하시면 되며, 거부 시 기존 초록이네 웹사이트에서 제공하던 구매내역과 포인트는 모두 소멸 처리가 됩니다.
    `,
    policy_7: `
    [개인정보 수집 및 이용에 관한 동의사항]<br>
전북현대모터스에프씨(주)는 아래의 목적으로 개인정보를 수집 및 이용하며, 회원의 개인정보를 안전하게 취급하는데 최선을 다합니다.<br>
1. 수집한 개인정보의 이용<br>
- 고객 만족도 조사 및 수집, 활용<br>
- 서비스, 제품 만족도 조사 및 수집, 활용<br>
<br>
2. 수집하는 개인정보 항목<br>
아이디, 이름, 연락처 및 설문조사 내 응답 내용<br>
<br>
3. 개인정보의 보유기간 및 이용기간<br>
수집된 정보는 회원 탈퇴 시 혹은 회원의 요청 시 개인정보는 삭제됩니다.<br> 
<br>
4. 동의 거부 권리 및 동의 거부 시 불이익 내용<br> 
동의 거부 시 설문조사에 참가 할 수 없습니다.`
,
    policy_8 :`
    전북현대모터스에프씨 주식회사는 전북현대모터스 경기 소식을 매 경기 종료 직후 문자메시지로 발송하고 있습니다.<br> 
<br> 
경기 소식은 "광고성 정보 수신 동의"를 완료한 회원을 대상으로 오후 9시(21시) 이전에 발송하고 있습니다.<br> 
오후 9시(21시) 이후에는 본 "야간 광고성 정보 수신 동의"를 완료한 회원에 한하여 경기 소식을 받아보실 수 있습니다.<br> 
<br> 
경기 소식은 평균적으로 경기 종료 후 30분 내 발송하며, 회원이 야간 광고성 정보 수신에 동의하였더라도 오후 11시(23시) 이후부터는 발송하지 않습니다.<br> 
<br> 
※ 회원이 "광고성 정보 수신"을 거부한 경우에는 "야간 광고성 정보 수신 동의"를 진행할 수 없습니다.<br> 
<br> 
※ 회원은 "야간 광고성 정보 수신"에 동의하지 않을 권리가 있습니다. 동의를 거부하는 경우에는 오후 9시 이후 경기 소식 제공이 어렵습니다. 그 밖의 불이익은 없습니다.
    `
    ,
    eventTerms: `
[유의사항 동의]<br>
- 2매 이상 시즌권 구매자의 경우, 응모 시 시즌권 구매 수량만큼 당첨되며 중복 응모 불가<br>
- 이벤트 당첨자 대상 개별 문자 안내 예정<br><br>
[개인정보 수집 및 이용에 관한 동의사항]<br>
전북현대모터스(주)는 아래의 목적으로 개인정보를 수집 및 이용하며, 회원의 개인정보를 안전하게 취급하는데 최선을 다합니다.<br><br>
1. 수집한 개인정보의 이용<br>
- 이용자 식별, 원활한 의사소통<br>
- 행사 시 정보 전달 및 민원 처리<br><br>
2. 수집하는 개인정보 항목<br>
아이디, 이름, 연락처<br><br>
3. 개인정보의 보유기간 및 이용기간<br>
수집된 정보는 이벤트 종료 후 이벤트 당첨자의 이벤트 참여 완료 된 이후 지체없이 파기됩니다.<br><br>
4. 동의 거부 권리 및 동의 거부 시 불이익 내용<br>
동의 거부 시 이벤트에 참가 할 수 없습니다.
    `
    ,
    eventTermForVote: `
[유의사항 동의]<br>
- 계정 당 1회 신청 가능합니다. (중복 투표 X)<br>
- 준비된 티켓 소진 시, 티켓 지급이 어려울 수 있습니다.<br>
- 티켓은 1인 1매 또는 2매로 제한되며, 좌석은 랜덤 배포됩니다.<br>
- 수령 시 신분증 확인하오니 당첨자 본인의 신분증을 지참바랍니다.<br>
- 노쇼(NO-SHOW)경우, 추후 이벤트 행사에 불이익이 있을 수 있습니다.<br>
<br>
[개인정보수집 및 이용에 관한 동의사항]<br>
전북현대모터스(주)는 아래의 목적으로 개인정보를 수집 및 이용하며, 회원의 개인정보를 안전하게 취급하는데 최선을 다합니다.<br>
<br>
1. 수집한 개인정보의 이용<br>
- 이용자 식별, 원활한 의사소통<br>
- 행사 시 정보 전달 및 민원 처리<br>
<br>
2. 수집하는 개인정보 항목<br>
아이디, 이름, 연락처<br>
<br>
3. 개인정보의 보유기간 및 이용기간<br>
수집된 정보는 이벤트 종료 후 이벤트 당첨자의 이벤트 참여 완료 된 이후 지체없이 파기됩니다.<br>
<br>
4. 동의 거부 권리 및 동의 거부 시 불이익 내용<br>
동의 거부 시 이벤트에 참가 할 수 없습니다.<br>
    `,
    policyOfGiftTk_1 : `
    전북현대모터스에프씨 주식회사(이하 전북현대)는 전북현대 스마트티켓 이용자(정보주체)께 개인정보의 수집∙이용 목적, 수집하는 개인정보의 항목, 개인정보의 보유∙이용 기간을 안내하고 있습니다. 자세히 읽은 후 동의여부를 선택하여 주시기 바랍니다.<br>
<br>
□ 개인정보의 수집∙이용 목적 안내<br>
전북현대는 스마트티켓 이용자의 개인정보 수집∙이용 목적에 대하여 「동의함」 버튼 또는 「동의 안 함」 버튼을 클릭할 수 있는 절차를 마련하여, 「동의함」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 간주합니다.<br>
<br>
전북현대 스마트티켓 서비스는 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다.<br>
수집한 개인정보는 고지한 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 이용자(정보주체)께 변경사항을 고지하고 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br>
<br>
□ 개인정보 수집 목적으로 처리하는 개인정보 항목<br>
: 휴대폰번호<br>
<br>
□ 개인정보의 세부 처리 목적<br>
스마트티켓 선물 전달 시, 관리 및 CS 활용 목적으로 사용됩니다.<br>
또한 부정이용 모니터링 및 관리를 위한 목적으로 활용됩니다.<br>
<br>
□ 개인정보 수집 방법<br>
- 전북현대가 운영하는 전북현대 스마트티켓 선물하기를 통한 수집<br>
- 티켓예매 위탁사를 통한 수집(개인정보의 제3자 제공)<br>
<br>
□ 개인정보 보유 및 이용 기간<br>
: 마지막 사용일 기준 1년까지 보관<br>
*1:1 문의 게시판을 통해 개인정보 폐기 요청 가능하며, 부정사용자는 모니터링을 위하여 10년 동안 보관됩니다.<br>
<br>
□ 동의를 거부할 권리 및 동의 거부 시 불이익<br>
스마트티켓 사용 시 수집하는 개인정보는 전북현대 스마트티켓 서비스 이용을 위해 필요한 최소한의 개인정보이므로 수집∙이용 동의를 해주셔야 서비스 이용이 가능합니다.<br>
이용자(정보주체)는 개인정보의 수집목적 및 이용목적에 대한 동의를 거부할 수 있으며, 동의 거부시 전북현대 스마트티켓 서비스 이용이 불가합니다. <br>
    `,
    policyOfGiftTk_2: `
    전북현대모터스에프씨 주식회사(이하 전북현대)는 전북현대 스마트티켓 이용자(정보주체)를 대상으로 맞춤형 마케팅을 진행하기 위하여 개인정보의 마케팅 활용 및 광고성 메시지 수신 동의를 받고 있습니다.<br>
<br>
□ 마케팅 목적으로 처리하는 개인정보 항목<br>
: 휴대폰번호<br>
<br>
□ 개인정보의 세부 처리 목적<br>
- 맞춤형 마케팅에 활용 : 스마트티켓 사용 빈도, 스마트티켓 사용 내역에 따른 포인트 지급, 쿠폰 제공<br>
- 맞춤형 메시지 발송에 활용 : 전자적 전송매체를 이용한 이벤트 정보, 프로모션 정보 등의 광고성 메시지 발송<br>
- 맞춤형 마케팅에 활용 : 스마트티켓 사용 빈도, 스마트티켓 사용 내역에 따른 포인트 지급, 쿠폰 제공<br>
<br>
□ 개인정보 수집 방법<br>
- 전북현대가 운영하는 전북현대 스마트티켓 선물하기를 통한 수집<br>
- 티켓예매 위탁사를 통한 수집(개인정보의 제3자 제공)<br>
<br>
④ 개인정보 보유 및 이용 기간<br>
: 이용자가 광고성 메시지 수신 동의를 거부할 시점까지 보관하며, 마지막 사용일 기준 1년까지 보관<br>
<br>
□ 동의를 거부할 권리 및 동의 거부 시 불이익<br>
: 이용자(정보주체)는 개인정보의 마케팅 활용 동의를 거부할 권리가 있습니다.<br>
단, 동의를 거부하는 경우에는 경품, 맞춤형 쿠폰, 기타 구단 정보 제공이 어렵습니다. 그 밖의 불이익은 없습니다.<br>
    `,
    quiz_info: `
    !!!! 예시입니다 추후 수정필요합니다 !!!!<br>
    <b>[참여 유의사항]</b><br>
• 셀프체크인으로 경기장 입장하신 분만 퀴즈 1회 참여 기회가 부여됩니다.<br>
• 셀프체크인은 OOOOOO에서 하실 수 있습니다.<br>
• 퀴즈의 답을 선택 후 [정답제출]을 누르면 참여가 완료됩니다.<br>
• 정답은 최초 1회 제출 후 재제출이 안됩니다.<br>
• [힌트보기]를 누르면 퀴즈의 힌트를 확인하실 수 있습니다.<br><br>
<b>[혜택 유의사항]</b><br>
• 당첨 혜택은 매 경기 변경될 수 있으며, 경품의 경우 재고에 따라 변경될 수 있습니다.<br>
• 당첨된 혜택 중 000000000(혜택이 미결정인 상태)<br><br>
<b>[그외 유의사항]</b><br>
해당 이벤트/혜택은 24시즌에만 적용됩니다.<br>
본 이벤트를 악용할 경우 이벤트 참여 대상에서 제외될 수 있습니다.<br>
    !!!! 예시입니다 추후 수정필요합니다 !!!!
    `,

}
